<template>
    <section>
        <div class="row">
            <div class="col-12">
                <customer-navigator></customer-navigator>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <customer-information></customer-information>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <customer-history></customer-history>
            </div>
        </div>
    </section>
</template>

<script>
import CustomerNavigator from '@/components/customer/Navigator';
import CustomerInformation from '@/components/customer/Information';
import CustomerHistory from '@/components/customer/History';

export default {
    components: {
        CustomerNavigator,
        CustomerInformation,
        CustomerHistory
    }
}
</script>